//@ts-check
import React, { useState } from "react"
import IconButton from '@material-ui/core/IconButton'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Divider from '@material-ui/core/Divider'
import Link from '@material-ui/core/Link'

/** 
 * @typedef { "DIVIDER" | {
 *   name: string;
 *   url?: () => string;
 *   onClick?: () => void;
 *   style?: Record<string, string>;
 * }} Option
 */

/**
 * @param {{ options: Option[] }} props
 */
export function ActionMenu({ options }) {
	const [anchorEl, setAnchorEl] = useState(null)
	const open = Boolean(anchorEl)
	const handleClick = event => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	return (
		<div>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
				onClick={handleClick}
				size="small"
			>
				<MoreVertIcon style={{ height: 20 }} />
			</IconButton>
			<Menu
				id="long-menu"
				anchorEl={anchorEl}
				keepMounted
				open={open}
				onClose={handleClose}
				PaperProps={{
					style: {
						padding: '0 8px',
					},
				}}
			>
				{options.length === 0 ?
					"No actions available" :
					options.map(option => {
						if (option === "DIVIDER") {
							return <Divider key={option} />
						}

						if (typeof option === "string") {
							console.warn(`unsupported action menu option: ${option}`)
							return undefined
						}

						const styles = { color: "inherit", fontSize: 14, ...(option ? option.style : {}) }

						if (option.url) {
							return (
								<Link
									key={option.name}
									href={option.url()}
									style={{ color: "inherit", fontSize: "inherit" }}
									target='_blank'
								>
									<MenuItem style={{ ...styles }}>
										{option.name}
									</MenuItem>
								</Link>
							)
						}

						const onClick = () => {
							if (option.onClick) {
								option.onClick()
							}
							handleClose()
						}

						return (
							<MenuItem key={option.name} onClick={onClick} style={styles}>
								{option.name}
							</MenuItem>
						)
					})}
			</Menu>
		</div>
	)
}
